// src/adminFlow/adminInvalidation.js
import { useEffect, useRef } from 'react';

export const INVALIDATION_KEY = 'ss-admin-invalidate';

/** Call this after a successful admin mutation to notify *other tabs*. */
export function broadcastInvalidation(type = 'generic', payload = {}) {
  try {
    const data = { type, payload, ts: Date.now() };
    localStorage.setItem(INVALIDATION_KEY, JSON.stringify(data));
  } catch {}
}

/** Listen for other tabs broadcasting invalidations and run onInvalidate(). */
export function useListenInvalidation(onInvalidate) {
  const cbRef = useRef(onInvalidate);
  cbRef.current = onInvalidate;

  useEffect(() => {
    function onStorage(e) {
      if (e.key !== INVALIDATION_KEY || !e.newValue) return;
      let data = null;
      try { data = JSON.parse(e.newValue); } catch {}
      if (data) cbRef.current?.(data);
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
}
